import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-logo',
  templateUrl: './page-logo.component.html',
  styleUrls: ['./page-logo.component.scss']
})
export class PageLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
